import { render, staticRenderFns } from "./AddonCaptureJs.vue?vue&type=template&id=b580dfa2&scoped=true&"
import script from "./AddonCaptureJs.vue?vue&type=script&lang=js&"
export * from "./AddonCaptureJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b580dfa2",
  null
  
)

export default component.exports